var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "banner-buttons",
    class: _vm.bannerButtonClasses
  }, [_c('v-btn', {
    class: _vm.vButtonFirstItemClass,
    style: {
      color: _vm.buttonColor === '#FFFFFF' || _vm.buttonColor === '#8BC5EB' ? '#001426' : '#FFFFFF'
    },
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": _vm.buttonColor
    },
    on: {
      "click": _vm.goToSelectedBlueprint
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonTitle) + " ")]), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoggedIn,
      expression: "!isLoggedIn"
    }],
    class: _vm.vButtonSecondItemClass,
    attrs: {
      "rounded": "",
      "outlined": "",
      "large": "",
      "color": "#FFFFFF"
    },
    on: {
      "click": _vm.goToAccountLogin
    }
  }, [_vm._v(" Login to my account ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }